import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** The Quoted PSF panel: blue surface, CALCULATED pill, derivation beneath. */
@Component({
  selector: 'ui-calculated-box',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-calculated-box.component.html',
})
export class UiCalculatedBoxComponent {
  readonly label = input.required<string>();
  readonly value = input.required<string>();
  readonly derivation = input('');
}
